import {css} from '../theme-provider';

export const boxShadowStyles = css`
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.06);
`;
